// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import NotFound from './components/NotFound'
import BuyNowAds from './components/BuyNowAds'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'

Vue.use(VueRouter)
Vue.use(VueI18n)

Vue.config.productionTip = false
console.log('APP INIT')
const routes = [
  { path: '/:campaignHash(.{36})/:productHash/', component: BuyNowAds },
  { path: '*', component: NotFound }
]

const messages = {
  de_de: {
    'Show more': 'Mehr anzeigen',
    'Privacy Policy': 'Datenschutzerklärung',
    'More information': 'Mehr Informationen',
    'Buy now': 'Jetzt kaufen',
    'Buy now online.': 'Jetzt Online kaufen.',
    'We update the inventory information regularly - subject to prior sale.': 'We update the inventory information regularly - subject to prior sale.'
  }
}

const i18n = new VueI18n({
  locale: 'en',
  messages
})

const router = new VueRouter({
  routes,
  mode: 'history'
})

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  template: '<App/>',
  components: { App },
  router
})



// WEBPACK FOOTER //
// ./src/main.js